import React, { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const Checkout = lazy(() => import('../../container/checkout/Checkout'));

function CheckoutRoutes() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={path} component={Checkout} />
    </Switch>
  );
}

export default CheckoutRoutes;
